import { render, staticRenderFns } from "./ProjectAdMaterialCreate.vue?vue&type=template&id=0237771b"
import script from "./ProjectAdMaterialCreate.vue?vue&type=script&lang=js"
export * from "./ProjectAdMaterialCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports